import { ILabel } from '../types.DrawIt';

export const adaptLabels = (labels: ILabel[], xMin: number, xMax: number) => {
    return labels.reduce((result, label) => {
        const isOutOfRange = label.values.reduce((boolean, value) => {
            if (value.year <= xMin - 2) {
                return true;
            } else {
                return boolean;
            }
        }, false);

        const values = label.values.map(value => {
            if (value.year > xMax) {
                return { year: xMax };
            } else if (value.year < xMin) {
                return { year: xMin };
            } else {
                return value;
            }
        });

        return isOutOfRange ? result : result.concat([{ ...label, values }]);
    }, [] as ILabel[]);
};
